// import React, { useState } from "react";
// import "./Register_page.css"
// function RegisterPage({ setShowMessage, setMessage, setError }) {
//   const [phoneNo, setPhoneNo] = useState('');
//   const [otp, setOtp] = useState('');
//   const [email, setEmail] = useState('');


//   async function handleOTP() {
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
//     if (phoneNo.trim().length() !== 10) {
//       console.log("phone hit");
//       setShowMessage(true);
//       setMessage("Please enter a valid phone number");
//       setError(true);
//       return;
//     }
//     if (!emailPattern.test(email)) {
//       console.log("email hit");
//       setShowMessage(true);
//       setMessage("Please enter a valid email address");
//       setError(true);
//       return;
//     }
//     try {
//       const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           "body": {
//             "action": "register",
//             "username": phoneNo,
//             "phone_number": phoneNo,
//             "email": email || ""
//           }
//         }),
//       });
//       const data = await response.json();
//       //console.log(data);
//       if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
//         setShowMessage(true);
//         setMessage("OTP Sent Successfully");
//         setError(false);
//       } else {
//         setShowMessage(true);
//         setMessage("Failed to send OTP, please try again");
//         setError(true);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function handleSubmit(e) {
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
//     if (phoneNo.trim().length() !== 10 ) {
//       console.log("phone hit");
//       setShowMessage(true);
//       setMessage("Please enter a valid phone number");
//       setError(true);
//       return;
//     }
//     if (!emailPattern.test(email)) {
//       console.log("email hit");
//       setShowMessage(true);
//       setMessage("Please enter a valid email address");
//       setError(true);
//       return;
//     }
//     if(!otp) {
//       setShowMessage(true);
//       setMessage("Please enter a valid OTP");
//       setError(true);
//       return;
//     }
//     e.preventDefault();
//     try {
//       const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           "body": {
//             "action": "validate_otp",
//             "username": phoneNo,
//             "phone_number": phoneNo,
//             "otp": otp
//           }
//         }),
//       });
//       const data = await response.json();
//       //console.log(data);
//       if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
//         setShowMessage(true);
//         setMessage("Register Successfully, please login");
//         setError(false);
//       } else {
//         setShowMessage(true);
//         setMessage("Failed to register, please try again");
//         setError(true);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }
//   return (
//     <div className="register-page-form">
//       <h2>Register</h2>
//       <p>Create new account today to reap the benefits of a personalized shopping experience.</p>
//       <div className='register-page-form-group'>
//         <label htmlFor="email">Email</label>
//         <input
//           type="email"
//           id="email"
//           onChange={(e) => setEmail(e.target.value)}
//         />
//       </div>
//       <div className='register-page-form-group'>
//         <label htmlFor="phone-no">Phone No.</label>
//         <input
//           type="number"
//           id="phone-no"
//           onChange={(e) => setPhoneNo(e.target.value)}
//         />
//       </div>
//       <button className='register-page-form-button' disabled={(phoneNo && email) ? false : true} onClick={handleOTP}>Send OTP</button>
//       <div className='register-page-form-group'>
//         <label htmlFor="otp">OTP</label>
//         <input
//           type="number"
//           id="otp"
//           onChange={(e) => setOtp(e.target.value)}
//         />
//       </div>
//       <button className='register-page-form-button' disabled={(otp) ? false : true} onClick={handleSubmit}>Register</button>
//     </div>
//   );
// }

// export default RegisterPage;


import React, { useState } from "react";
import "./Register_page.css";

function RegisterPage({ setShowMessage, setMessage, setError }) {
  const [phoneNo, setPhoneNo] = useState('');
  const [otp, setOtp] = useState('');
  const [email, setEmail] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [emailPhoneButtonClicked, setEmailPhoneButtonClicked] = useState(false);
  const [otpButtonClicked, setOtpButtonClicked] = useState(false);

  // Handle phone number input with validation
  const handlePhoneChange = (e) => {
    const input = e.target.value;
    // Only allow numbers and limit to 10 digits
    if (/^\d*$/.test(input) && input.length <= 10) {
      setPhoneNo(input);
    }
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailPattern.test(email);
  };

  async function handleOTP() {
    // Fixed: using length as a property instead of a function
    setEmailPhoneButtonClicked(true);
    if (phoneNo.trim().length !== 10) {
      setShowMessage(true);
      setMessage("Please enter a valid 10-digit phone number");
      setError(true);
      return;
    }
    
    if (!isValidEmail(email)) {
      setShowMessage(true);
      setMessage("Please enter a valid email address");
      setError(true);
      return;
    }
    
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "register",
            "username": phoneNo,
            "phone_number": phoneNo,
            "email": email || ""
          }
        }),
      });
      const data = await response.json();
      
      if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
        setShowMessage(true);
        setMessage("OTP Sent Successfully");
        setError(false);
        setIsOtpSent(true);
      } else {
        setShowMessage(true);
        setMessage("Failed to send OTP, please try again");
        setError(true);
      }
    } catch (error) {
      console.log(error);
      setShowMessage(true);
      setMessage("An error occurred. Please try again later.");
      setError(true);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    setOtpButtonClicked(true);
    // Fixed: using length as a property instead of a function
    if (phoneNo.trim().length !== 10) {
      setShowMessage(true);
      setMessage("Please enter a valid 10-digit phone number");
      setError(true);
      return;
    }
    
    if (!isValidEmail(email)) {
      setShowMessage(true);
      setMessage("Please enter a valid email address");
      setError(true);
      return;
    }
    
    if (!otp) {
      setShowMessage(true);
      setMessage("Please enter a valid OTP");
      setError(true);
      return;
    }
    
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "validate_otp",
            "username": phoneNo,
            "phone_number": phoneNo,
            "otp": otp
          }
        }),
      });
      const data = await response.json();
      
      if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
        setShowMessage(true);
        setMessage("Registration Successful, please login");
        setError(false);
        // Reset form after successful registration
        setPhoneNo('');
        setEmail('');
        setOtp('');
        setIsOtpSent(false);
      } else {
        setShowMessage(true);
        setMessage("Failed to register, please try again");
        setError(true);
      }
    } catch (error) {
      console.log(error);
      setShowMessage(true);
      setMessage("An error occurred. Please try again later.");
      setError(true);
    }
  }

  return (
    <div className="register-page-form">
      <h2>Register</h2>
      <p>Create new account today to reap the benefits of a personalized shopping experience.</p>
      
      <div className='register-page-form-group'>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
        />
        {email && !isValidEmail(email) && (
          <p className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
            Please enter a valid email address
          </p>
        )}
      </div>
      
      <div className='register-page-form-group'>
        <label htmlFor="phone-no">Phone No. <span>(Sample: 1234567890)</span></label>
        <input
          type="tel"
          id="phone-no"
          value={phoneNo}
          onChange={handlePhoneChange}
          placeholder="Enter your 10-digit phone number"
          maxLength="10"
        />
        {phoneNo && phoneNo.length !== 10 && (
          <p className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
            Phone number must be 10 digits
          </p>
        )}
      </div>
      
      <button 
        className='register-page-form-button' 
        disabled={!(phoneNo && phoneNo.length === 10 && isValidEmail(email))}
        onClick={handleOTP}
        style={emailPhoneButtonClicked ? { backgroundColor: 'rgba(0, 0, 0, 0.438)' } : {}}
      >
        Send OTP
      </button>
      
      <div className='register-page-form-group'>
        <label htmlFor="otp">OTP</label>
        <input
          type="text"
          id="otp"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          disabled={!isOtpSent}
        />
      </div>
      
      <button 
        className='register-page-form-button' 
        disabled={!(otp && isOtpSent)}
        onClick={handleSubmit}
        style={otpButtonClicked ? { backgroundColor: 'rgba(0, 0, 0, 0.438)' } : {}}
      >
        Register
      </button>
    </div>
  );
}

export default RegisterPage;